import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

interface WorkspaceBadgeProps {
  tenantType: string | null;
}

export function WorkspaceBadge({ tenantType }: WorkspaceBadgeProps) {
  const { t } = useTranslation('onboarding');
  if (tenantType === 'organization') {
    return <Badge tone="accent">{t('workspaceType.organization')}</Badge>;
  }
  return (
    <Badge tone="neutral" className="border border-zooprimary/30">
      {t('workspaceType.solo')}
    </Badge>
  );
}
